import { cleanRut } from '../cleanRut';
import { DEFAULT_RUT } from '../default';

const splitRut = (fullRut: string): [string, string] => {
  let cleanedRut = cleanRut(fullRut);

  if (cleanedRut.length < 2) {
    cleanedRut = DEFAULT_RUT;
  }

  if (cleanedRut.includes('-')) {
    const [rut, dv] = cleanedRut.split('-');

    return [rut, dv];
  }

  const rut = cleanedRut.slice(0, cleanedRut.length - 1);
  const dv = cleanedRut[cleanedRut.length - 1];

  return [rut, dv];
};

export { splitRut };
